import { fetchOrderLineItems } from '../fetchers';
import { OrderLineItemDTO } from '../interfaces/orderLineItem.interfaces';

export const getOrderLineItems = async (
  orderId: string,
  organizationId: number,
) => {
  const { data: orderLineItems } = await fetchOrderLineItems({
    orderId,
    organizationId,
  });

  const orderLineItemsDTO = orderLineItems.map((item) => {
    return OrderLineItemDTO.fromApiData(item);
  });

  return orderLineItemsDTO;
};
